import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { NgTemplateOutlet } from '@angular/common'
import { Component, DestroyRef, inject, input, signal } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import {
  TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX,
  TOOLTIP_DEFAULT_DELAY,
} from '@flowx/designer/modules/core/dictionary/constants'
import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'

import { NotificationSummary, SummarySegmentType } from '../notifications-payload.model'

/** How long the copy button shows its check after a copy. */
const COPIED_CONFIRMATION_MS = 2000

@Component({
  selector: 'flx-notification-summary',
  imports: [
    CdkCopyToClipboard,
    NgTemplateOutlet,
    TooltipModule,
    FlxButtonModule,
    FlxIconModule,
    FlxClickStopPropagationDirective,
  ],
  templateUrl: './notification-summary.component.html',
  host: {
    class: 'block',
  },
})
export class FlxNotificationSummaryComponent {
  #copiedConfirmationTimer?: ReturnType<typeof setTimeout>

  TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY
  TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX = TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX
  SummarySegmentType = SummarySegmentType

  summary = input.required<NotificationSummary>()

  idCopied = signal(false)

  constructor() {
    inject(DestroyRef).onDestroy(() => clearTimeout(this.#copiedConfirmationTimer))
  }

  onIdCopied(copied: boolean): void {
    if (copied) {
      clearTimeout(this.#copiedConfirmationTimer)
      this.idCopied.set(true)

      this.#copiedConfirmationTimer = setTimeout(
        () => this.idCopied.set(false),
        COPIED_CONFIRMATION_MS
      )
    }
  }
}
